import { useLocale } from '../useLocale';
import { useQuery } from '@tanstack/react-query';

export function useDateFnsLocale() {
  const locale = useLocale();

  const { data, status } = useQuery({
    queryKey: ['dateFnsLocale', locale] as const,
    queryFn: async ({ queryKey }) => {
      const { 1: locale } = queryKey;

      /**
       * Can't get around ModuleErrorNotFound when using dynamic import with a variable.
       *
       * ie `await import('date-fns/locale/${locale}')`
       *
       */
      switch (locale) {
        case 'de':
          return (await import('date-fns/locale/de')).de;
        case 'es':
          return (await import('date-fns/locale/es')).es;
        case 'ja':
          return (await import('date-fns/locale/ja')).ja;
        case 'ko':
          return (await import('date-fns/locale/ko')).ko;
        default:
          return (await import('date-fns/locale/en-US')).enUS;
      }
    },
    enabled: !!locale,
  });

  if (status !== 'success') {
    return { status };
  }

  return { locale: data, status };
}
